// EmailVerificationPrompt.tsx

import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';

export const EmailVerificationPrompt = () => {
  const location = useLocation();
  const { email, role } = location.state || {
    email: sessionStorage.getItem('emailForVerification'),
    role: sessionStorage.getItem('roleForVerification'),
  };

  useEffect(() => {
    console.log('EmailVerificationPrompt gerendert mit:', { email, role });
    // Optional: Sitzungsspeicher nach dem Lesen löschen, um alte Daten zu vermeiden
    sessionStorage.removeItem('emailForVerification');
    sessionStorage.removeItem('roleForVerification');
  }, [email, role]);

  return (
    <div className="text-center px-4 sm:px-0">
      <h2 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mb-4">
        E-Mail-Bestätigung erforderlich
      </h2>
      <p className="text-base sm:text-sm text-gray-600 dark:text-gray-400 mb-6">
        Wir haben Ihnen eine E-Mail an <strong>{email || 'Ihre E-Mail-Adresse'}</strong> gesendet.
        Bitte klicken Sie auf den Link in der E-Mail, um Ihre Registrierung abzuschließen.
      </p>
      {role === 'manager' ? (
        <span className="block mt-2 text-sm text-gray-600 dark:text-gray-400">
          Nach der E-Mail-Bestätigung wird Ihr Konto von einem Administrator freigeschaltet.
        </span>
      ) : (
        <span className="block mt-2 text-sm text-gray-600 dark:text-gray-400">
          Sie können sich nach der E-Mail-Bestätigung anmelden.
        </span>
      )}
      <p className="text-sm text-gray-500 dark:text-gray-400 mt-4">
        Keine E-Mail erhalten? Überprüfen Sie Ihren Spam-Ordner oder{' '}
        <Link
          to="/register"
          className="text-indigo-600 hover:text-indigo-500 dark:text-indigo-400 dark:hover:text-indigo-300"
        >
          versuchen Sie es erneut
        </Link>
      </p>
      <div className="text-sm text-center pt-4">
        <span className="text-gray-600 dark:text-gray-400">Bereits ein Konto? </span>
        <Link
          to="/"
          className="font-medium text-indigo-600 hover:text-indigo-500 dark:text-indigo-400 dark:hover:text-indigo-300"
        >
          Hier anmelden
        </Link>
      </div>
    </div>
  );
};

export default EmailVerificationPrompt;
